import { TronDialog } from './tron'

export default function App() {
  return (
    <>
      <TronDialog />
    </>
  )
}
